var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00008 0.666748C6.36827 0.666748 6.66675 0.965225 6.66675 1.33341V5.33342H10.6667C11.0349 5.33342 11.3334 5.63189 11.3334 6.00008C11.3334 6.36827 11.0349 6.66675 10.6667 6.66675H6.66675V10.6667C6.66675 11.0349 6.36827 11.3334 6.00008 11.3334C5.63189 11.3334 5.33342 11.0349 5.33342 10.6667V6.66675H1.33341C0.965225 6.66675 0.666748 6.36827 0.666748 6.00008C0.666748 5.63189 0.965225 5.33342 1.33341 5.33342H5.33342V1.33341C5.33342 0.965225 5.63189 0.666748 6.00008 0.666748Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSign);
export default __webpack_public_path__ + "static/media/add_sign.17e3656c41a55f535d7a27082a832565.svg";
export { ForwardRef as ReactComponent };